import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Observable } from 'rxjs';
import { environment, oldEnvironment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'LMS Leads'
  env = environment;
  oldEnv = oldEnvironment;
  database = '';

  constructor(public http:HttpClient, private router: Router) {}

  ngOnInit(): void {
	// (window as any).appComponent = this;
    this.getDatabaseName();
  }

  getDatabaseName() {
    this.http.get(`${environment.api}config/get_database`).subscribe(
			(data: any) => {
				this.database = data.body.database_name;
			},
			(error: any) => {
				console.error('Error fetching database name:', error);
			}
		);
  }
}
